import { categories } from './DesignSection.config';

export const getCategories = ({
  properties,
  layerType,
}: {
  properties: any;
  layerType: any;
}) => {
  let nextCategories = [...categories];

  const parent = properties.find((property: any) => property.key === 'parent');

  if (
    !parent ||
    !parent.value ||
    (parent.value.type !== 'FRAME' &&
      parent.value.type !== 'COMPONENT_SET' &&
      parent.value.type !== 'COMPONENT' &&
      parent.value.type !== 'INSTANCE' &&
      parent.value.type !== 'GROUP' &&
      parent.value.type !== 'BOOLEAN_OPERATION')
  ) {
    nextCategories = nextCategories.filter(
      (category: any) => category.variant !== 'CONSTRAINTS',
    );
  }

  if (layerType !== 'TEXT') {
    nextCategories = nextCategories.filter(
      (category: any) => category.variant !== 'TEXT',
    );
  }

  // Shapes and text can be pinned with «Ignore auto layout» too — the key is
  // recorded only for children of an auto-layout frame.
  const canIgnoreAutoLayout = properties.some(
    (property: any) => property.key === 'layoutPositioning',
  );

  if (
    !canIgnoreAutoLayout &&
    !(
      layerType === 'FRAME' ||
      layerType === 'COMPONENT' ||
      layerType === 'INSTANCE'
    )
  ) {
    nextCategories = nextCategories.filter(
      (category: any) => category.variant !== 'AUTO_LAYOUT',
    );
  }

  if (
    layerType !== 'FRAME' &&
    layerType !== 'COMPONENT_SET' &&
    layerType !== 'COMPONENT' &&
    layerType !== 'INSTANCE'
  ) {
    nextCategories = nextCategories.filter(
      (category: any) => category.variant !== 'LAYOUT_GRID',
    );
  }

  if (layerType !== 'COMPONENT') {
    nextCategories = nextCategories.filter(
      (category: any) => category.variant !== 'COMPONENT',
    );
  }

  if (layerType !== 'COMPONENT_SET') {
    nextCategories = nextCategories.filter(
      (category: any) => category.variant !== 'COMPONENT_SET',
    );
  }

  if (layerType !== 'INSTANCE') {
    nextCategories = nextCategories.filter(
      (category: any) => category.variant !== 'COMPONENT_INSTANCE',
    );
  }

  // if (
  //   layerType !== 'COMPONENT_SET' &&
  //   layerType !== 'COMPONENT' &&
  //   layerType !== 'INSTANCE' &&
  //   (!parent || !parent.value)
  // ) {
  //   // ONLY FOR ROOT FRAME
  //   nextCategories = nextCategories.filter(
  //     (category) => category.variant !== 'COMPONENT',
  //   );
  // }

  switch (layerType) {
    case 'FRAME': {
      return nextCategories;
    }
    case 'GROUP': {
      return nextCategories
        .filter((category: any) => category.variant !== 'FILL')
        .filter((category: any) => category.variant !== 'STROKE')
        .filter((category: any) => category.variant !== 'CONSTRAINTS');
    }
    case 'RECTANGLE':
    case 'ELLIPSE':
    case 'LINE':
    case 'STAR':
    case 'REGULAR_POLYGON':
    case 'TEXT':
    case 'BOOLEAN_OPERATION':
    case 'COMPONENT':
    case 'COMPONENT_SET':
    case 'INSTANCE':
    case 'VECTOR': {
      return nextCategories;
    }
    default: {
      return [];
    }
  }
};
